import { initialPaso1Seleccion } from './state'

export default {
  setLimiteTurnosEntradaValidado(state, value) {
    state.limiteTurnosEntradaValidado = value === true
  },
  setPaso2ResumenLoading(state, v) {
    state.paso2ResumenLoading = !!v
  },
  setPaso2ResumenFetchEnCurso(state, v) {
    state.paso2ResumenFetchEnCurso = !!v
  },
  setPaso2ResumenError(state, e) {
    state.paso2ResumenError = e ?? null
  },
  setSedesConTurnoDisponible(state, items) {
    state.sedesConTurnoDisponible = Array.isArray(items) ? [...items] : []
  },
  setPaso2Seleccion(state, { ubicId, modalidad }) {
    state.paso2Seleccion = {
      ubicId: ubicId == null || ubicId === '' ? null : Number(ubicId),
      modalidad:
        modalidad === 'presencial' || modalidad === 'video' ? modalidad : null,
    }
    if (!Number.isFinite(state.paso2Seleccion.ubicId)) {
      state.paso2Seleccion.ubicId = null
    }
  },
  setPaso1Seleccion(state, payload) {
    if (!payload || typeof payload !== 'object') return
    const target = state.paso1Seleccion
    for (const k of Object.keys(payload)) {
      target[k] = payload[k]
    }
  },
  resetPaso1Seleccion(state) {
    state.paso1Seleccion = initialPaso1Seleccion()
  },
  clearPedidoMedicoSeleccionado(state) {
    state.paso1Seleccion.pedidoMedicoSeleccionado = null
    state.paso1Seleccion.pedEstPId = null
    state.paso1Seleccion.practicasAsociadas = []
  },
  setPaso3SlotSeleccionado(state, slot) {
    state.paso3SlotSeleccionado = slot == null ? null : { ...slot }
  },
  setPaso3CalendarioLoading(state, v) {
    state.paso3CalendarioLoading = !!v
  },
  setPaso3CalendarioError(state, e) {
    state.paso3CalendarioError = e ?? null
  },
  setPaso3CalendarioCacheEntry(state, { key, dias }) {
    if (!key) return
    state.paso3CalendarioCache = {
      ...state.paso3CalendarioCache,
      [key]: Array.isArray(dias) ? dias : [],
    }
  },
  clearPaso3CalendarioCache(state) {
    state.paso3CalendarioCache = {}
  },
  setPaso4Contacto(state, payload) {
    const cur = state.paso4Contacto || {
      email: '',
      celular: '',
      telefono: '',
      observaciones: '',
    }
    const p = payload || {}
    const pick = (k) => (p[k] !== undefined ? String(p[k]) : cur[k])
    state.paso4Contacto = {
      email: pick('email'),
      celular: pick('celular'),
      telefono: pick('telefono'),
      observaciones: pick('observaciones'),
    }
  },
  setPaso4ContactoListo(state, v) {
    state.paso4ContactoListo = !!v
  },
  resetAsistentePasoUbicacion(state) {
    state.paso2ResumenLoading = false
    state.paso2ResumenFetchEnCurso = false
    state.paso2ResumenError = null
    state.sedesConTurnoDisponible = []
    state.paso2Seleccion = { ubicId: null, modalidad: null }
    state.paso3SlotSeleccionado = null
    state.paso3CalendarioCache = {}
    state.paso3CalendarioLoading = false
    state.paso3CalendarioError = null
    state.paso4Contacto = {
      email: '',
      celular: '',
      telefono: '',
      observaciones: '',
    }
    state.paso4ContactoListo = false
  },
}
